import React, { useState } from 'react';

import { SaveButton ,
  List,
  Datagrid,
  TextField,
  DeleteButton,
  SelectInput,
  TextInput,
  useTranslate,
  required,    
  useCreate,
  useUpdate,
  useNotify,
  FormWithRedirect,useRefresh,
  Button,
  FunctionField, TopToolbar, NumberInput, ResourceContextProvider,
  ArrayField, ArrayInput,SimpleFormIterator 
} from 'react-admin';


import EditIcon from '@material-ui/icons/Edit';

import { useStyles  } from '../common/styles';




import Divider from '@mui/material/Divider';

import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';


import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';


import { validateMaxLength, validateInteger  } from './../components/Validator';

import { choicesShowsType, choicesAdult  } from './../common/constants';

export const UsersShowsList = (props) => {
  const translate = useTranslate(); 
    
  let strRedirect =  `/users/${props.users_id}/more_federation`; 
    
  return (
           
    <ResourceContextProvider value="users_shows" >
      <List 
        syncWithLocation 
        basePath="/users_shows" 
        filter={{ users_id : props.users_id }}  
        title=""
        bulkActionButtons={false}                
        actions={<CustomToolbar users_id={props.users_id} /> }  
        perPage={1000}
        sort={{ field: 'year', order: 'ASC' }} 
        empty={<CustomToolbar users_id={props.users_id} /> } 
        pagination={false}
      >

        <Datagrid   
          expand={<UsersShowsDetails />} 
          className="header_grey6"
          label=""
          fullWidth
        >
          <TextField source="year" label={translate('common.year')} sortable={false} /> 
          <FunctionField label={translate('users_shows.total_quantity')} render={record => <RenderTotalQuantity record={record} /> } sortable={false} />
          <FunctionField label={translate('users_shows.total_assistants')} render={record => <RenderTotalAssistants record={record} /> } sortable={false} />
          <FunctionField label={translate('users_shows.total_inversion')} render={record => <RenderTotalInversion record={record} /> } sortable={false} />    
          <CustomEditButton label=""/>
          <DeleteButton undoable={false} redirect={strRedirect} label=""/>
        </Datagrid>

      </List> 
    </ResourceContextProvider>

  );
};


export const CustomEditButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [update, { loading, error }] = useUpdate();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };
                        
  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'users_shows', 
        payload : { id: values.id, data : 
                {       users_id: values.users_id,
                  year : values.year, 
                  items: values.items
                } }
      },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    

  return (
    <>
      <Button onClick={handleClick} label="" startIcon={<EditIcon />} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
      >
        <DialogTitle>{translate('users_shows.edit')}</DialogTitle>

        <FormWithRedirect
          resource=""
          save={handleSubmit}
          initialValues={{ id : props.record.id, 
            users_id: props.record.users_id,
            year : props.record.year, 
            items: props.record.items
          }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <CustomForm edit={true} />
                            
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const RenderTotalQuantity = ({ record, ...props }) => {
    
  let total_quantity = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.quantity) total_quantity+=element.quantity; } );
  }
    
  return ( total_quantity );
    
};

const RenderTotalAssistants = ({ record, ...props }) => {
    
  let total_assistants = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.assistants) total_assistants+=element.assistants; } );
  }
    
  return ( total_assistants );
    
};

const RenderTotalInversion = ({ record, ...props }) => {
    
  let total_inversion = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.inversion) total_inversion+=element.inversion; } );
  }
    
  return ( total_inversion );
    
};

export const UsersShowsShow = ({ ...props }) => {
  const translate = useTranslate();   

  return (
        
    <ResourceContextProvider value="users_shows" >
      <List 
        syncWithLocation 
        basePath="/users_shows" 
        filter={{ users_id : props.users_id }}  
        title=""
        bulkActionButtons={false}                                
        perPage={1000}
        sort={{ field: 'year', order: 'ASC' }} 
        pagination={false}
        actions={false}
        empty={<></>}
        className="users_remittances_list"
      >                            
        <Datagrid
          expand={<UsersShowsDetails />} 
          className="header_grey6"
          fullWidth
        >   
          <TextField source="year" label={translate('common.year')} sortable={false}  />                        
          <FunctionField label={translate('users_shows.total_quantity')} render={record => <RenderTotalQuantity record={record} /> } sortable={false} />
          <FunctionField label={translate('users_shows.total_assistants')} render={record => <RenderTotalAssistants record={record} /> } sortable={false} />
          <FunctionField label={translate('users_shows.total_inversion')} render={record => <RenderTotalInversion record={record} /> } sortable={false} />                
        </Datagrid>

      </List> 

    </ResourceContextProvider>            

  );
};

export const CustomToolbar = ({ ...props }) => {

  return (
        
    <TopToolbar>
      <CustomCreateButton users_id={props.users_id} />
    </TopToolbar>
        
  );
};


export const CustomCreateButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('users_shows');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
    

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };


  return (
    <>            
      <Button onClick={handleClick} label={translate('users_shows.create_button')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('users_shows.create')}
      >
        <DialogTitle>{translate('users_shows.create')}</DialogTitle>

        <FormWithRedirect
          resource="users_shows"
          save={handleSubmit}
          initialValues={{ users_id : props.users_id }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <CustomForm edit={false} />
                            
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const CustomForm = ({ edit, ...props }) => {
  const translate = useTranslate(); 
  const classes = useStyles();
    
  return (
    <DialogContent className="users_shows_form">
      <br />
      <Grid container spacing={2} >
        <Grid item xs={3}>  
          { edit ? (
            <NumberInput label={translate('common.year')} fullWidth source="year" step={1} disabled />                                        
          ) : (
            <NumberInput label={translate('common.year')} fullWidth source="year" step={1} validate={[required(),validateInteger(translate('common.validation.number'))]} />                           
          )}
        </Grid> 
      </Grid>
                
      <ArrayInput source="items" label="">
        <SimpleFormIterator 
          disableReordering                     
        >
          <SelectInput fullWidth label={translate('users_shows.type')} source="type" choices={choicesShowsType(translate)} validate={[required()]} />
          <SelectInput fullWidth label={translate('users_shows.amateur')} source="amateur" choices={[                        
            { id: 1, name: translate('users_shows.amateur_1')  },
            { id: 2, name: translate('users_shows.amateur_2')  }
          ]} resettable />
          <SelectInput fullWidth label={translate('users_shows.adult')} source="adult" choices={choicesAdult(translate)} resettable />                    
          <NumberInput source="quantity" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_shows.quantity')} />
          <NumberInput source="assistants" step={1} validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_shows.assistants')} />
          <NumberInput source="inversion" validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_shows.inversion')} />
          <NumberInput source="occupancy" validate={[validateInteger(translate('common.validation.number'))]} label={translate('users_shows.occupancy')} />
          <TextInput fullWidth source="comment" validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} label={translate('common.comment')} />
                            
        </SimpleFormIterator>
      </ArrayInput>
                        
    </DialogContent>
  );
    
    
};
    

export const UsersShowsDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  let total_quantity = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.quantity) total_quantity+=element.quantity; } );
  }
    
  let total_assistants = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.assistants) total_assistants+=element.assistants; } );
  }
    
  let total_inversion = 0;
  if (record.items)
  {
    record.items.forEach(element => { if (element.inversion) total_inversion+=element.inversion; } );
  }
    
    
  return (
    <div className="usersEconomicDataExpand">
      <Grid container spacing={2}>
        <Grid item xs={2} >
          <FunctionField render={record => <TextFieldShow source={record.year} label={translate('common.year')} /> } />
        </Grid>
        <Grid item xs={3} >
          <FunctionField render={record => <TextFieldShow source={total_quantity} label={translate('users_shows.total_quantity')} /> } />
        </Grid>
        <Grid item xs={3} >
          <FunctionField render={record => <TextFieldShow source={total_assistants} label={translate('users_shows.total_assistants')} /> } />
        </Grid>
        <Grid item xs={3} >
          <FunctionField render={record => <TextFieldShow source={total_inversion} label={translate('users_shows.total_inversion')} /> } />
        </Grid>
      </Grid>
        
      <br />
      <Divider className="" />
      <br />
      <ArrayField source="items">
        <Datagrid>
          <FunctionField render={record => record.type ? translate('users_shows.type_' + record.type) : '' } label={translate('users_shows.type')} />
          <FunctionField render={record => record.amateur ? translate('users_shows.amateur_' + record.amateur) : '' } label={translate('users_shows.amateur')} />
          <FunctionField render={record => record.adult ? translate('users_shows.adult_' + record.adult) : '' } label={translate('users_shows.adult')} />
          <TextField source="quantity" label={translate('users_shows.quantity')} />
          <TextField source="assistants" label={translate('users_shows.assistants')} />
          <TextField source="inversion" label={translate('users_shows.inversion')} />
          <TextField source="occupancy" label={translate('users_shows.occupancy')} />
          <TextField source="comment" label={translate('common.comment')} />
        </Datagrid>
      </ArrayField>
        
      <br /> 
    </div>
  );
};